// extracted by mini-css-extract-plugin
export default {"postDescriptionV1":"post_description_v1_postDescriptionV1__5LO3a","contentText":"post_description_v1_contentText__YDx6n","contentName":"post_description_v1_contentName__CGkEA"};